import $ from "jquery"
import Flickity from "flickity"
import "flickity-imagesloaded"
import "flickity-fade"

/**
 * Javascript
 *
 * This example module logs a greeting to the console and makes the function
 * 'sayGreeting' available via import.
 */

let flickities = [];

const makeOnlyVisibleCellsFocusable = (slides) => {
	let $slide
	$(slides).each((index, target) => {
		$slide = $(target);
		$slide.find("*").attr("tabindex", "-1");
		if ($slide.hasClass("is-selected")) {
			$slide.find("*").removeAttr("tabindex");
		}
	});
}

const setSliders = (slider, sliderConfig, sliderWrap = "", sliderNextPrev) => {
	let carousel, flkty;
	$(slider).each((index, target) => {
		carousel = target;

		// Init flickity
		flkty = new Flickity(carousel, sliderConfig);

		if (sliderNextPrev.prev) {
			carousel
				.closest(sliderWrap)
				.querySelector("[data-carousel-previous-button]")
				.addEventListener("click", e => {
					e.preventDefault();
					flkty.previous();
				});
		}

		if (sliderNextPrev.next) {
			carousel
				.closest(sliderWrap)
				.querySelector("[data-carousel-next-button]")
				.addEventListener("click", e => {
					e.preventDefault();
					flkty.next();
				});
		}

		flickities.push(flkty);
	})
}

// General Carousel/Navigation Carousel
const carousel = document.querySelectorAll("[data-carousel]")
const carouselCells = document.querySelectorAll("[data-carousel-cell]")
const carouselConfig = {
	cellAlign: "left",
	groupCells: false,
	contain: true,
	// pageDots: false,
	// prevNextButtons: false,
	wrapAround: true,
	lazyLoad: 4,
	imagesLoaded: true,
	// autoPlay: 4000,
	// pauseAutoPlayOnHover: true,
	on: {
		ready: () => {
			setTimeout(() => {
				makeOnlyVisibleCellsFocusable(carouselCells);
			}, 100);
		},
		change: () => {
			makeOnlyVisibleCellsFocusable(carouselCells);
		}
	}
}
const carouselWrap = "[data-carousel-wrap]"
const carouselNextPrev = {
	next: false,
	prev: false,
}

setSliders(
	carousel,
	carouselConfig,
	carouselWrap,
	carouselNextPrev
)

// Invoke a resize to ensure slide height isn't miscalculated by fonts loading after
$(() => {
	window.dispatchEvent(new Event("resize"));
});

export default flickities;
